import React, { useState,useContext } from "react";
import Header from "./Header/Header";
import MessagesListContainer from "./MessagesListContainer/MessagesListContainer";
import MessageBox from "./MessageBox/MessageBox";
import ThreeDotsLoader from "./ThreeDotsLoader/ThreeDotsLoader";
import Footer from "./Footer/Footer";
import Button from "./Button/Button";
import useLocalStorageState from "../../../Hooks/useLocalStorageState";
import { AIAsisstentServices } from "../../../Services/ai-assistant.services";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./AIChatModal.css";
import { AuthContext } from "../../../Contexts/AuthContext";

const AIChatModal = () => {
  const { t: translator } = useTranslation();
  const { roleId } = useContext(AuthContext);

  const [show, setShow] = useState(false);
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [chatId, setChatId] = useLocalStorageState("AI_CHAT_ID");

  useEffect(() => {
    if (!chatId) return;
    setIsLoading(true);
    AIAsisstentServices.getMessages({
      chatId,
    })
      .then((res) => {
        setMessages(res?.results || []);
      })
      .catch((err) => {
        console.error("Error fetching messages:", err);
      })
      .finally(() => setIsLoading(false));
  }, []);

  const handleSendMessage = async (msg) => {
    const updatedArray = messages?.filter((msg) => !msg.hasError);

    setMessages((x) => [
      ...updatedArray,
      { message: msg, id: new Date().toISOString(), messageType: "user" },
    ]);

    try {
      setIsLoading(true);
      const response = await AIAsisstentServices.createMessage({
        chatId,
        message: msg,
      });

      if (!response?.chatId) {
        setMessages([
          ...updatedArray,
          {
            message: msg,
            id: new Date().toISOString(),
            messageType: "user",
            hasError: true,
          },
        ]);
        return;
      }

      if (!chatId && response.chatId) {
        setChatId(response.chatId);
      }
      if (response.id) {
        setMessages((x) => [
          ...x,
          {
            id: response.id,
            message: response.message,
            messageType: response.messageType,
          },
        ]);
        return;
      }
    } catch (error) {
      setMessages([
        ...updatedArray,
        {
          message: msg,
          id: new Date().toISOString(),
          messageType: "user",
          hasError: true,
        },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetChat = () => {
    setChatId(undefined);
    setMessages([]);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div className="root">
      {show && (
        <>
          <div
            className="ai-chat-modal__overlay"
            onClick={() => setShow(false)}
          ></div>
          <div className="chat-container">
            <Header onClose={handleClose} roleId={roleId} />
            <MessagesListContainer dependencyArray={[messages]}>
              {messages.length === 0 && !isLoading && (
                <div className="ai-empty-message">
                  {roleId < 3 ? translator("AI-Chat-Empty-Message"):translator("AIUser-Chat-Empty-Message")}
                </div>
              )}
              {messages.map((message) => (
                <MessageBox
                  key={message.id}
                  messageType={message.messageType}
                  message={message.message}
                  hasError={message.hasError}
                  onResendMessage={() => handleSendMessage(message.message)}
                />
              ))}
              {isLoading && (
                <div className="d-flex justify-content-start w-100">
                  <ThreeDotsLoader />
                </div>
              )}
            </MessagesListContainer>
            <Footer
              onResetChat={handleResetChat}
              onSendMessage={handleSendMessage}
              isLoading={isLoading}
            />
          </div>
        </>
      )}

      {!show && (
        <Button
          onClick={() => setShow((x) => !x)}
          className="ai-chat-modal__trigger-button"
        >
          <i className="far fa-comments" />
        </Button>
      )}
    </div>
  );
};

export default AIChatModal;
